//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.TurningOperationBuilder.js";
import "../CAM/CAM.TrimPlane.js";
import "../CAM/CAM.TurnCircularFeedComp.js";
import "../CAM/CAM.TurnCutParameters.js";
import "../CAM/CAM.CutAngle.js";
import "../CAM/CAM.TrimPoint.js";
let d=[[[1,"AxialTrimPlane1",0,"CAM.TrimPlane",0],[1,"AxialTrimPlane2",0,"CAM.TrimPlane",0],[0,"ChipBreakingDistance",1,0],[0,"ChipBreakingMode",1,0],[0,"ChipBreakingRetractLength",1,0],[0,"ChipBreakingRetractMode",1,0],[1,"CircularFeedCompBuilder",0,"CAM.TurnCircularFeedComp",0],[0,"CustomMemberData",1,0],[0,"CustomMemberDataDistance",1,0],[0,"CustomPartBoundary",0,"CAM.Boundary",0],[1,"CutParameters",0,"CAM.TurnCutParameters",0],[0,"CutRegions",1,0],[0,"EndAngle",1,0],[0,"EndOffset",1,0],[0,"ExtendMode",1,0],[0,"IgnoreMinimumBoringDiameter",1,0],[1,"LevelAngleBuilder",0,"CAM.CutAngle",0],[0,"MaximumAreaMode",1,0],[0,"MaximumAreaSize",1,0],[0,"MaximumAreaUnit",1,0],[0,"MaximumSizeAxial",0,"CAM.InheritableToolDepBuilder",0],[0,"MaximumSizeMode",1,0],[0,"MaximumSizeRadial",0,"CAM.InheritableToolDepBuilder",0],[0,"MinimumArea",1,0],[0,"MinimumAreaSize",1,0],[0,"MinimumAreaUnit",1,0],[0,"MinimumSizeAxial",0,"CAM.InheritableToolDepBuilder",0],[0,"MinimumSizeMode",1,0],[0,"MinimumSizeRadial",0,"CAM.InheritableToolDepBuilder",0],[0,"MultiChannelTurningLeadDistance",1,0],[0,"MultiChannelTurningLeadMode",1,0],[0,"MultiChannelTurningLeadRevolutions",1,0],[0,"MultiChannelTurningLeadTime",1,0],[0,"MultiChannelTurningMode",1,0],[0,"MultiChannelTurningSafeDistanceToCenterline",1,0],[0,"MultiChannelTurningSecondTool",1,"CAM.Tool",0],[0,"OmitReversals",1,0],[1,"RadialTrimPlane1",0,"CAM.TrimPlane",0],[1,"RadialTrimPlane2",0,"CAM.TrimPlane",0],[0,"RegionMachining",1,0],[0,"RegionSelection",1,0],[0,"RegionSelectionPoint",1,"Point",0],[0,"StartAngle",1,0],[0,"StartOffset",1,0],[1,"StepAngleBuilder",0,"CAM.CutAngle",0],[0,"ToleranceOffset",1,0],[1,"TrimPoint1",0,"CAM.TrimPoint",0],[1,"TrimPoint2",0,"CAM.TrimPoint",0]],[],[]];
SPLM.CAM.RoughFinishTurningBuilder = class extends SPLM.CAM.TurningOperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.RoughFinishTurningBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.RoughFinishTurningBuilder.CustomMemberDataTypes = Object.freeze({
    "WithinRegion" : "WithinRegion", "WithinDistance" : "WithinDistance"});

SPLM.CAM.RoughFinishTurningBuilder.RegionMachiningTypes = Object.freeze({
    "Single" : "Single", "Multiple" : "Multiple"});

SPLM.CAM.RoughFinishTurningBuilder.CutRegionsTypes = Object.freeze({
    "SingleRegion" : "SingleRegion", "SingleDirection" : "SingleDirection", "ReverseDirection" : "ReverseDirection", "BiDirectional" : "BiDirectional", "Alternate" : "Alternate"});

SPLM.CAM.RoughFinishTurningBuilder.ToleranceOffsetTypes = Object.freeze({
    "AfterContainment" : "AfterContainment", "BeforeContainment" : "BeforeContainment"});

SPLM.CAM.RoughFinishTurningBuilder.MinimumAreaTypes = Object.freeze({
    "None" : "None", "Specify" : "Specify", "Partunit" : "Partunit", "Tool" : "Tool"});

SPLM.CAM.RoughFinishTurningBuilder.MaximumAreaModes = Object.freeze({
    "None" : "None", "Partunit" : "Partunit", "Tool" : "Tool"});

SPLM.CAM.RoughFinishTurningBuilder.MinmaxSizeModes = Object.freeze({
    "None" : "None", "Axial" : "Axial", "Radial" : "Radial", "AxialAndRadial" : "AxialAndRadial"});

SPLM.CAM.RoughFinishTurningBuilder.MinmaxAreaUnits = Object.freeze({
    "Square" : "Square", "Percentage" : "Percentage"});

SPLM.CAM.RoughFinishTurningBuilder.MinmaxSizeUnits = Object.freeze({
    "Length" : "Length", "Percentage" : "Percentage"});

SPLM.CAM.RoughFinishTurningBuilder.ExtendModeTypes = Object.freeze({
    "Specify" : "Specify", "Tagential" : "Tagential", "Tangential" : "Tangential"});

SPLM.CAM.RoughFinishTurningBuilder.MultiChannelTurningModeTypes = Object.freeze({
    "None" : "None", "Balanced" : "Balanced", "Merged" : "Merged"});

SPLM.CAM.RoughFinishTurningBuilder.MultiChannelTurningLeadModeTypes = Object.freeze({
    "Distance" : "Distance", "TimeFromDistnace" : "TimeFromDistnace", "Time" : "Time", "Revolutions" : "Revolutions"});

SPLM.CAM.RoughFinishTurningBuilder.ChipBreakingModeTypes = Object.freeze({
    "None" : "None", "Distance" : "Distance"});

SPLM.CAM.RoughFinishTurningBuilder.ChipBreakingRetractModeTypes = Object.freeze({
    "FromTool" : "FromTool", "Length" : "Length"});

SPLM.CAM.RoughFinishTurningBuilder.RegionSelectionTypes = Object.freeze({
    "Automatic" : "Automatic", "Manual" : "Manual"});

export default SPLM;